import { User } from 'lucide-react';

export interface ViewingOtherResourceBannerProps {
  isViewingOtherResource: boolean;
  viewedResourceName: string | null;
}

/**
 * Notice shown when drilling into another resource's timesheet from the
 * Timesheet Report, so it is clear whose timesheet is on screen.
 */
export function ViewingOtherResourceBanner({
  isViewingOtherResource,
  viewedResourceName,
}: ViewingOtherResourceBannerProps) {
  if (!isViewingOtherResource || !viewedResourceName) return null;

  return (
    <div className="pb-2">
      <div className="flex items-start gap-2 border border-blue-400 bg-blue-50 dark:bg-blue-950/20 rounded px-3 py-2">
        <User className="h-4 w-4 text-blue-600 dark:text-blue-400 flex-shrink-0 mt-0.5" />
        <span className="text-blue-800 dark:text-blue-200 leading-tight" style={{ fontSize: '12px' }}>
          You are viewing <span className="font-semibold">{viewedResourceName}</span>'s timesheet.
        </span>
      </div>
    </div>
  );
}
